import ActionTypes from './action-types';
import { ENDPOINT } from 'constants/endpoints';

const showLoader = () => ({
  type: ActionTypes.LOADER_SHOW,
});

const hideLoader = () => ({
  type: ActionTypes.LOADER_HIDE,
});

const setHeaderTitle = title => ({
  type: ActionTypes.SET_HEADER_TITLE,
  payload: title,
});

export default {
  showLoader,
  hideLoader,
  setHeaderTitle,
};

export const readOptions = () => ({
  type: ActionTypes.GET_OPTIONS,
  tag: {},
  meta: {
    type: 'api',
    options: {
      method: 'get',
      url: ENDPOINT.OTHER.GLOBAL_OPTIONS,
    },
  },
});
